// همه‌ی صفحات گزارش پشت پرمیشن ReportManager هستند — همان پرمیشنی که
// اندپوینت‌های api/report/* بک‌اند هم با آن گارد می‌شوند.
const meta = pageTitle => ({
  pageTitle,
  action: 'show',
  resource: 'ReportManager',
})

export default [
  {
    path: '/report/sales',
    name: 'report-sales',
    component: () => import('@/views/menu/report/sales.vue'),
    meta: meta('گزارش فروش'),
  },
  {
    path: '/report/products',
    name: 'report-products',
    component: () => import('@/views/menu/report/products.vue'),
    meta: meta('گزارش محصولات'),
  },
  {
    path: '/report/customers',
    name: 'report-customers',
    component: () => import('@/views/menu/report/customers.vue'),
    meta: meta('گزارش مشتریان'),
  },
  {
    path: '/report/abandoned',
    name: 'report-abandoned',
    component: () => import('@/views/menu/report/abandoned.vue'),
    meta: meta('گزارش سبد رهاشده'),
  },
  {
    path: '/report/coupons',
    name: 'report-coupons',
    component: () => import('@/views/menu/report/coupons.vue'),
    meta: meta('گزارش کدهای تخفیف'),
  },
  {
    path: '/report/traffic',
    name: 'report-traffic',
    component: () => import('@/views/menu/report/traffic.vue'),
    meta: meta('گزارش ترافیک'),
  },
  {
    path: '/report/content',
    name: 'report-content',
    component: () => import('@/views/menu/report/content.vue'),
    meta: meta('گزارش محتوا'),
  },
  {
    path: '/report/leads',
    name: 'report-leads',
    component: () => import('@/views/menu/report/leads.vue'),
    meta: meta('گزارش سرنخ‌ها'),
  },
  {
    path: '/report/duty',
    name: 'report-duty',
    component: () => import('@/views/menu/report/duty.vue'),
    meta: meta('گزارش خدمات'),
  },
  {
    path: '/report/operations',
    name: 'report-operations',
    component: () => import('@/views/menu/report/operations.vue'),
    meta: meta('سلامت سیستم'),
  },
]
